/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Shared state data
 * -----------------------------------------------------------------------------
 *
 * @namespace store
 */

const store = {
  // Elements via data attributes
  selectors: {
    // sitePreloader: '[data-site-preloader]',
    productObj: '[data-product-json]',
    siteOverlay: '[data-site-overlay]',
    siteHeader: '[data-site-header]',
    searchLayer: '[data-search-layer]',
    newsletterPopup: '[data-newsletter-popup]',
    carousel: '[data-flickity]',
    productToolbarMobile: '[data-product-toolbar-mobile]',
    productTabs: '[data-product-tabs]',
    accountTabs: '[data-account-tabs]',
    singleOptionSelector: '[data-single-option-selector]',
    qtyContainer: '[data-qty-container]',
    qtyInput: '[data-qty-input]',
    cartItem: '[data-cart-item]',
    productForm: '[data-product-form]',
    cartForm: '[data-cart-form]',
    loginForm: '[data-login-form]',
    recoverForm: '[data-recover-form]',
    passwordInput: '[data-password-input]',
    imageZoom: '[data-img-zoom]',
    dataHeading: '[data-heading]',
    dataContent: '[data-content]',
    collprObj: '[data-collections-coll-json]',
    articleData: '[data-article-content]',
  },

  // Global objects
  currentTemplate: null,
  isLoading: false,
  pro_Available_flag: false,
  currentActiveLink: 'div_1',
  activeClass: true,
  cart_item_id: [],
  moneyFormat: window.theme.moneyFormat,
  sizeSwatchesEnabled: window.theme.sizeSwatchesEnabled,
  productExcludeTag: window.theme.productExcludeTag,
  showReview: false,
  loadCart: false,
  // Recharge code start
  // ReCharge Integration
  reChargeDiscountVariantId: null,
  // Recharge code end
  meta_days: '',
};

export default store;

